import {Chip} from "@mui/material";
import dayjs, {Dayjs} from "dayjs";
import React from "react";
import {formatCurrency} from "../../../../helpers";
import {Card, Colors, Container, Text} from "../../../../ui";
import {FormattedDate} from "../../../components";
import {IHighlightedInstallment, mapStatusToIcon} from "../utils";

interface IPayNextCard {
  installment: IHighlightedInstallment;
  numberOfInstallments: number;
}

export const PayNextCard = ({installment, numberOfInstallments}: IPayNextCard) => {
  const {Icon, label, labelColor} = mapStatusToIcon[installment.installment_status];
  const getDate = (dateString: Date): Dayjs => {
    return dayjs.utc(dateString).startOf("day");
  };
  const dueDate = getDate(installment.due_date);

  return (
    <Card
      row
      fullWidth
      sx={{
        gap: "4px",
        padding: "16px",
        backgroundColor: Colors.tertiary._100,
        borderColor: Colors.tertiary._300,
      }}
    >
      <Container fullWidth sx={{alignItems: "start", gap: "5px"}}>
        <Container row>
          <Text size={14}>{`Installment ${installment.index}/${numberOfInstallments}`}</Text>
          {label && Icon && (
            <Chip
              icon={<Icon style={{width: "16px", height: "16px"}} />}
              label={
                <Text variant={"inter600"} size={12} sx={{textTransform: "none", color: labelColor}}>
                  {label}
                </Text>
              }
              sx={{
                height: "22px",
                border: `1px solid ${labelColor}`,
                borderRadius: "6px",
                gap: "4px",
                backgroundColor: Colors.tertiary._100,
              }}
            />
          )}
        </Container>
        <Text size={20} fontWeight={"bold"} sx={{display: "inline"}}>
          {formatCurrency(installment.amount_cents)}
        </Text>
        <Text size={14} sx={{display: "inline"}}>
          Due on{" "}
          <Text size={14} variant={"inter600"} sx={{display: "inline"}}>
            <FormattedDate date={dueDate} />
          </Text>
        </Text>
      </Container>
    </Card>
  );
};
